import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { lightTheme } from "./style";
import { ThemeProvider, makeStyles } from "@material-ui/core/styles";

import "./App.css";

import NavBar from "./Components/NavBar";
import Footer from "./Components/Footer";
import ScrollToTop from "./Components/ScrollToTop";
import Home from "./Pages/Home";
import BaseWeight from "./Pages/Projects/BaseWeight";
import Relier from "./Pages/Projects/Relier";


// TO DO: figure out how to override main styles
const useStyles = makeStyles((theme) => ({
  palette: {
    type: "light",
  },
}));

function App() {
  const classes = useStyles();

  return (
    <BrowserRouter>
      <ThemeProvider theme={lightTheme}>
        <ScrollToTop />
        <NavBar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/project/baseweight" component={BaseWeight} />
          <Route path="/project/relier" exact component={Relier} />
        </Switch>
        <Footer />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
